(function(angular) {
    'use strict';

    angular.module('um.categories').controller('categories.overview.controller', categoriesOverviewCtrl);

    categoriesOverviewCtrl.$inject = ['$modal', 'categoriesService', 'trackingService'];

    function categoriesOverviewCtrl($modal, categoriesService, trackingService) {
        var that = this;

        this.$onInit = function() {
            return categoriesService.getAllCategories(true).then(function(categories) {
                that.categories = categories;
            });
        };

        that.predicate = 'name';
        that.reverse = false;
        that.tableHeaders = [
            {
                active: true,
                sortable: true,
                searchable: true,
                predicate: 'name',
                i18n: 'CATEGORY_NAME',
                reverse: false,
                width: 3
            }, {
                active: true,
                sortable: false,
                searchable: true,
                predicate: 'desc',
                i18n: 'CATEGORY_DESCRIPTION',
                reverse: false,
                width: 4
            }, {
                active: true,
                sortable: false,
                searchable: true,
                predicate: 'roles',
                i18n: 'CATEGORY_ROLES',
                reverse: false,
                width: 4
            }, {
                active: false,
                sortable: false,
                searchable: false,
                predicate: null,
                i18n: 'ACTIONS',
                reverse: false,
                width: 1
            }
        ];

        that.selectedSearchKey = '$';

        that.elementList = _.filter([{
            active: true,
            searchable: true,
            predicate: '$',
            i18n: 'FILTER_ANY'
        }].concat(that.tableHeaders), function(el) {
            return el.searchable;
        });

        that.search = {
            $: ''
        };

        that.elementMapping = {
            key: 'predicate',
            title: 'i18n',
            active: 'active'
        };

        that.clickHandlers = {
            leftClick: function(index, element) {
                var searchText;
                if (element && element.predicate) {
                    searchText = that.search[that.selectedSearchKey];
                    that.selectedSearchKey = element.predicate;
                    that.search = {};
                    that.search[that.selectedSearchKey] = searchText;
                }
            }
        };

        that.sortHeader = function(tableHeader) {
            if (tableHeader.predicate) {
                tableHeader.reverse = !tableHeader.reverse;
                that.predicate = tableHeader.predicate;
                that.reverse = tableHeader.reverse;
            }
        };

        that.deleteCategory = function deleteCategory(category) {
            trackingService.action('category.delete');
            that.modalInstance = $modal.open({
                templateUrl: 'template/modal/assureConfirmDelete.html',
                controller: 'categories.delete.controller',
                resolve: {
                    category: function() {
                        return _.cloneDeep(category);
                    }
                }
            });
        };

        /**
         * Checks the highlighting should be done on search or not
         * That is the case if either 'Any' or the matching predicate is selected
         *
         * @param {String} predicate
         * @returns {*} Value key in search object or false value
         */
        that.checkHighlighting = function checkHighlighting(predicate) {
            if (that.selectedSearchKey === predicate || that.selectedSearchKey === that.elementList[0].predicate) {
                return that.search[that.selectedSearchKey];
            }
            return '';
        };
    }
})(window.angular);
